import { t } from "@/language/translation";
import { IssueCustomAttributesType, SQDCTileEventTypes } from "@/graphql";
import type { IssueEditType } from "../event/modal/EventEditType";

export function injectCustomAttributesForSBB(event: IssueEditType, type: SQDCTileEventTypes) {
  if (event.customAttributes == null) {
    event.customAttributes = [];
  }
  if (event.customAttributes.length === 0) {
    if (type === SQDCTileEventTypes.SBBFaultyPart) {
      event.description = t("module.sbb.SBBFaultyPart") ?? "Fehlteil";
      event.customAttributes.push({
        type: IssueCustomAttributesType.TEXT,
        name: "VehicleNR", // t("module.sbb.VehicleNR")
        value: null,
        required: true,
      });
      event.customAttributes.push({
        type: IssueCustomAttributesType.TEXT,
        name: "ArticelMissingPart", // t("module.sbb.ArticelMissingPart")
        value: null,
        required: true,
      });
    }
    if (type === SQDCTileEventTypes.SBBSparePart) {
      event.description = t("module.sbb.SBBSparePart") ?? "Sonderfreigabe";
      event.customAttributes.push({
        type: IssueCustomAttributesType.TEXT,
        name: "VehicleNR", // t("module.sbb.VehicleNR")
        value: undefined,
        required: true,
      });
      event.customAttributes.push({
        type: IssueCustomAttributesType.TEXT,
        name: "Articel", // t("module.sbb.Articel")
        value: null,
        required: true,
      });
      event.customAttributes.push({
        type: IssueCustomAttributesType.NUMBER,
        name: "Quantity", // t("module.sbb.Quantity")
        value: null,
        required: true,
      });
      event.customAttributes.push({
        type: IssueCustomAttributesType.TEXT,
        name: "Place", // t("module.sbb.Place")
        value: null,
        required: false,
      });
    }

    if (type === SQDCTileEventTypes.SBBAccident) {
      event.customAttributes.push({
        type: IssueCustomAttributesType.TEXTAREA,
        name: "TypeOfHazard", // t("module.sbb.TypeOfHazard")
        placeholder: "TypeOfHazardPlaceholder", // t("module.sbb.TypeOfHazardPlaceholder")
        value: undefined,
        required: true,
      });

      event.customAttributes.push({
        type: IssueCustomAttributesType.TEXTAREA,
        name: "PossibleConsequences", // t("module.sbb.PossibleConsequences")
        placeholder: "PossibleConsequencesPlaceholder", // t("module.sbb.PossibleConsequencesPlaceholder")
        value: null,
        required: true,
      });
      event.customAttributes.push({
        type: IssueCustomAttributesType.TEXTAREA,
        name: "Rule", // t("module.sbb.Rule")
        placeholder: "PossibleRulePlaceholder", // t("module.sbb.PossibleRulePlaceholder")
        value: null,
        required: true,
      });
    }

    if (type === SQDCTileEventTypes.SBBAndon) {
      event.customAttributes.push({
        type: IssueCustomAttributesType.TEXT,
        name: "FAArticleNumber", // t("module.sbb.FAArticleNumber")
        placeholder: "",
        value: undefined,
        required: true,
      });

      event.customAttributes.push({
        type: IssueCustomAttributesType.TEXT,
        name: "FANumber", // t("module.sbb.FANumber")
        placeholder: "",
        value: undefined,
        required: true,
      });
      event.customAttributes.push({
        type: IssueCustomAttributesType.TEXT,
        name: "Utility", // t("module.sbb.Utility")
        placeholder: "",
        value: undefined,
        required: false,
      });

      event.customAttributes.push({
        type: IssueCustomAttributesType.TEXT,
        name: "Line", // t("module.sbb.Line")
        placeholder: "",
        value: undefined,
        required: false,
      });

      event.customAttributes.push({
        type: IssueCustomAttributesType.TEXT,
        name: "AndonReason", // t("module.sbb.AndonReason")
        placeholder: "",
        value: undefined,
        required: true,
      });
    }
  }
}
